module.exports = function() {
  return new Worker(__webpack_public_path__ + "4fccf38fcdfe85c6a6fe.worker.js");
};